import TrainTypeReferenceItem from './train-type-reference-item';

export default TrainTypeReferenceItem;